import _ from 'lodash'
import query from './query'

export default (cache, {
  data: {
    deleteModel: {
      id,
    },
  },
}) => {
  const { models } = cache.readQuery({ query })

  cache.writeQuery({
    query,
    data: { models: _.reject(models, { id }) },
  })
}
